import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-price-list-factors',
  templateUrl: './price-list-factors.component.html',
  styleUrls: ['./price-list-factors.component.css']
})
export class PriceListFactorsComponent implements OnInit {
    argType;

    argValue;

    public edit?: Edit;

    public inputListFactors: FactorItem[] = [];

    public saving = false;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.argType = this.stateService.getStateParams()['argtype'];
        this.argValue = this.stateService.getStateParams()['argvalue'];
    }

    private async loadEdit() {
        if (!!this.argType && !!this.argValue) {
            this.edit = (await this.datatask.Post(670, {
                argtype: this.argType,
                argvalue: this.argValue
            }))[0];
        }
    }

    private async loadFactors() {
        if (!!this.argType && !!this.argValue) {
            this.inputListFactors = await this.datatask.Post(669, {
                argtype: this.argType,
                argvalue: this.argValue
            });
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                await this.datatask.Post(671, {
                    argtype: this.argType,
                    argvalue: this.argValue,
                    items: this.inputListFactors
                });

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
        this.loadFactors();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    heading_id: string;
    heading_name: string;
}

interface FactorItem {
    pricelistfactor_keyno: number;
    factorbased_factor: string;
    pricelist_id: string;
    pricelist_name: string;
    orderby: number;
}
